import { RefObject, useCallback, useEffect, useRef } from 'react'

type CallbackType = () => void
const useOutsideClick = (ref: RefObject<Element | null>, callback: CallbackType): void => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const currentElement = ref.current
      if (!currentElement || !currentElement.contains(event.target as Node)) {
        savedCallback.current()
      }
    },
    [ref],
  )

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [handleClickOutside])
}

export default useOutsideClick
